export default __webpack_public_path__ + "static/benefitSection1Bg-9f6a84c55ba256fed3be30cf90378276.png";